import React from "react";

import InputSurveyInput from "../survey-input/input";
import MatrixSurveyInput from "../survey-input/matrix";
import OptionsSurveyInput from "../survey-input/options";
import RangeSurveyInput from "../survey-input/range";
import TextAreaSurveyInput from "../survey-input/text-area";
import DropdownSurveyInput from "../survey-input/dropdown";

const QuestionFormField = ({ questionType, questionDetails }) => {
  const renderByQuestionType = () => {
    switch (questionType) {
      case "input":
        return <InputSurveyInput {...questionDetails} />;
      case "textarea":
        return <TextAreaSurveyInput {...questionDetails} />;
      case "range":
        return <RangeSurveyInput {...questionDetails} />;
      case "options":
        return <OptionsSurveyInput {...questionDetails} />;
      case "dropdown":
        return <DropdownSurveyInput {...questionDetails} />;
      case "matrix":
        return <MatrixSurveyInput {...questionDetails} />;
      default:
        return <div></div>;
    }
  };

  return <div className="survey-input">{renderByQuestionType()}</div>;
};

export default QuestionFormField;
